import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Pipe({
	name: 'domsanitizer'
})
export class DomsanitizerPipe implements PipeTransform {

	constructor (private _domS: DomSanitizer){

	}

	transform(data: string, type:string): SafeUrl | SafeResourceUrl | SafeHtml {

	
		switch(type){
			case 'url':
				return this._domS.bypassSecurityTrustUrl(data);
				break;
			case 'resoruceUrl':
				return this._domS.bypassSecurityTrustResourceUrl(data);
				break;
			case 'html':
				return this._domS.bypassSecurityTrustHtml(data);
				break;
			default:
				return data;
				break;
		}
	


	}



	

}
